import { uuidv7 as generateUuidv7 } from "uuidv7";

export function uuidv7(): string {
  return generateUuidv7();
}

export function uuidv7Timestamp(uuid: string): number {
  const hex = uuid.replace(/-/g, "").slice(0, 12);
  return parseInt(hex, 16);
}
